module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "topbar no-select",
    class: {
      contextual: _vm.contextual
    }
  }, [_c('a', {
    staticClass: "topbar-backbtn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "homeicon"
    }
  }, [(!_vm.canGoBack && !_vm.contextual) ? _c('img', {
    attrs: {
      "src": "/static/img/icons/android-chrome-192x192.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backicon"
    }
  }, [(_vm.canGoBack && !_vm.contextual) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backicon"
    }
  }, [(_vm.contextual) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })]) : _vm._e()])], 1), _vm._v(" "), (!_vm.contextual) ? _c('span', {
    staticClass: "topbar-title"
  }, [_vm._v("Flipcards")]) : _vm._e(), _vm._v(" "), (_vm.contextual) ? _c('span', {
    staticClass: "topbar-title"
  }, [_vm._v(_vm._s(_vm.contextualTitle))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "links-direct"
  }, [_vm._l((_vm.items), function(item) {
    return _c('button', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.itemClicked(item.id)
        }
      }
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "#ffffff",
        "d": item.svgPath
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), (item.shortcut) ? _c('Tooltip', [_vm._v(_vm._s(item.shortcut))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.signedIn && !_vm.contextual) ? _c('button', {
    staticClass: "link",
    on: {
      "click": _vm.signOut
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Sign Out")])]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0 || _vm.signedIn) ? _c('button', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.menuOpen = !_vm.menuOpen
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Menu")])]) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "overflow"
    }
  }, [(_vm.menuOpen) ? _c('div', {
    staticClass: "overflow-menu"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.menuOpen = !_vm.menuOpen
      }
    }
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('button', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.itemClicked(item.id)
        }
      }
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "d": item.svgPath
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), (item.shortcut) ? _c('Tooltip', [_vm._v(_vm._s(item.shortcut))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.signedIn && !_vm.contextual) ? _c('button', {
    staticClass: "link",
    on: {
      "click": _vm.signOut
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Sign Out")])]) : _vm._e()], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c6bf0d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar.vue
// module id = 291
// module chunks = 1